import { createEnum } from "../../../utils/utils";

export interface ResetPasswordLoggedOutRequest {
  password: string;
  confirmPassword: string;
}

export const Roles = createEnum({
  ROLE_ADMIN: "ROLE_ADMIN",
  ROLE_USER: "ROLE_USER",
  ROLE_COMMUNITY_MANAGER: "ROLE_COMMUNITY_MANAGER",
  ROLE_MERCHANT: "ROLE_MERCHANT",
  ROLE_CRYPTO: "ROLE_CRYPTO",
});

export const MerchantProductTypes = createEnum({
  KYC: "KYC",
  KYB: "KYB",
  AML: "AML",
  VAULT: "Vault",
  TRANSACTION_MONITORING: "Transaction Monitoring",
  WALLET_ON_CHAIN_ANALYSIS: "Wallet OnChain Analysis",
});
